import React from 'react';


const FilterStats = ({ 
  totalCount = 0, 
  filteredCount = 0, 
  searchTerm = '', 
  selectedGenre = 'all',
  stats = null 
}) => {
  const isFiltered = searchTerm || selectedGenre !== 'all';
  
  return (
    <div className="mb-6">
      {/* Results Summary - Updated to match gradient theme */}
      <div className="flex items-center justify-between bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 p-4 rounded-lg">
        <div className="flex items-center space-x-4">
          <div className="text-sm text-blue-100">
            {isFiltered ? (
              <>
                Showing <span className="font-semibold text-white">{filteredCount}</span> of{' '}
                <span className="font-semibold text-white">{totalCount}</span> songs
                {searchTerm && (
                  <span className="ml-2">
                    for "<span className="font-medium text-white">{searchTerm}</span>"
                  </span>
                )}
                {selectedGenre !== 'all' && (
                  <span className="ml-2">
                    in <span className="font-medium capitalize text-white">{selectedGenre}</span> genre
                  </span>
                )}
              </>
            ) : (
              <>
                <span className="font-semibold text-white">{totalCount}</span> total songs
              </>
            )}
          </div>
        </div>

        {/* Clear Filters Button */}
        {isFiltered && (
          <button
            onClick={() => {
              // This would be handled by parent component
              window.location?.reload();
            }}
            className="text-sm text-blue-200 hover:text-white font-medium transition-colors"
          >
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterStats;